import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Linkedin, Youtube, Mail } from "lucide-react";
import { B2C_EXTERNAL_URL } from "../config/brand";

const LOGO_URL = "/amazonico-logo.png";

const SOCIAL = [
  { icon: Instagram, href: "https://www.instagram.com/amazonico3000", label: "Instagram" },
  { icon: Facebook, href: "https://www.facebook.com/amazonico3000", label: "Facebook" },
  { icon: Linkedin, href: "https://www.linkedin.com/company/amazonico-3000", label: "LinkedIn" },
  { icon: Youtube, href: "https://www.youtube.com/@amazonico3000", label: "YouTube" },
];

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          {/* Brand column */}
          <div className="col-span-2 lg:col-span-2">
            <img src={LOGO_URL} alt="Amazonico 3000" className="h-24 md:h-28 mb-6 object-contain" />
            <p className="text-sm text-white/60 leading-relaxed max-w-md">
              Amazonico 3000 è la piattaforma B2B ExportTech che unisce marketplace, AI, servizi export,
              rivista mensile e presenza locale in Brasile per l&apos;eccellenza agroalimentare italiana nel mondo.
            </p>
            <div className="mt-6 flex gap-2">
              {SOCIAL.map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  data-testid={`footer-social-${s.label.toLowerCase()}`}
                  className="w-10 h-10 border border-white/20 hover:border-[#C9A961] hover:bg-[#C9A961] flex items-center justify-center text-white/70 hover:text-white transition-colors"
                >
                  <s.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <FooterCol title="Piattaforma">
            <FLink to="/">Home</FLink>
            <FLink to="/b2b/wines">Marketplace</FLink>
            <FLink to="/rivista">Rivista mensile</FLink>
            <FLink to="/ai-ricette">Ricette & Abbinamenti</FLink>
            <FLink to="/gestionale">Gestionale B2B</FLink>
            <FLink to="/tv">Amazonico TV</FLink>
          </FooterCol>

          <FooterCol title="Azienda">
            <FLink to="/il-progetto">Chi siamo</FLink>
            <FLink to="/gestionale/pitch">Pitch commerciale</FLink>
            <FLink to="/#piani">Piani di affiliazione</FLink>
            <FLink to="/supporto">Supporto</FLink>
            <FLink to="/register">Diventa partner</FLink>
            <li>
              <a href={B2C_EXTERNAL_URL} target="_blank" rel="noopener noreferrer" className="text-sm text-white/70 hover:text-[#C9A961] transition-colors">
                Storefront MZN 300 ↗
              </a>
            </li>
          </FooterCol>

          <FooterCol title="Contatti">
            <li className="text-sm text-white/70 flex items-start gap-2">
              <Mail className="h-3.5 w-3.5 mt-1 text-[#C9A961] shrink-0" />
              <a href="mailto:info@amazonico3000.com" className="hover:text-[#C9A961]">info@amazonico3000.com</a>
            </li>
          </FooterCol>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/40">
          <div>© {year} Amazonico 3000 · ExportTech Platform · Tutti i diritti riservati</div>
          <div className="flex flex-wrap gap-6">
            <Link to="/privacy" className="hover:text-[#C9A961]">Privacy</Link>
            <Link to="/cookie" className="hover:text-[#C9A961]">Cookie</Link>
            <Link to="/termini" className="hover:text-[#C9A961]">Termini</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, children }) {
  return (
    <div>
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#C9A961] font-bold mb-4">{title}</div>
      <ul className="space-y-2.5">{children}</ul>
    </div>
  );
}

function FLink({ to, children }) {
  return (
    <li>
      <Link to={to} className="text-sm text-white/70 hover:text-[#C9A961] transition-colors">{children}</Link>
    </li>
  );
}
